import * as yup from 'yup';

export const InstitutionsValidationSchema = yup.object().shape({
  name: yup.string().required( 'El nombre es requerido' ),
  email: yup.string().required( 'El correo es requerido' ),
  phone: yup.mixed().required( 'El número de teléfono es requerido' ),
  photo: yup.mixed().required( 'La foto es requerida' ),
});
